"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = exports.registerAll = exports.get = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var onceOnly_sidecar_1 = require("@lib/onceOnly-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var _default = {
    type: 'default',
    frames: sprites_sidecar_1.sprites.diveEffectsCloud3,
    // bounceOnSurface: true,
    accelY: 2,
    minTimeSeconds: 0,
    maxTimeSeconds: 2,
    playFrames: false,
    dirXrange: [-1, 1],
    dirYrange: [-0.1, -1],
    offsetXrange: [0, 0],
    offsetYrange: [0, 0],
    sineX: 0,
    sineXperiod: 0,
    afterCreate: null,
    scale: 1,
    shrink: false,
};
var dataType = 'dive-particles';
var dataList = [];
var dataMapType = {};
var get = function (type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetData(dataType, dataMapType, type);
};
exports.get = get;
var registerAll = function () {
    onceOnly_sidecar_1.onceOnly.ensureCalledOnlyOnce(dataType);
    exports.register(_default);
    exports.register({
        type: 'poof',
        frames: __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveEffectsCloud1)), __read(sprites_sidecar_1.sprites.diveEffectsCloud2)), __read(sprites_sidecar_1.sprites.diveEffectsCloud3)),
        // accelY: 0.5,
        accelY: 0,
        minTimeSeconds: 0.5,
        maxTimeSeconds: 1.55,
        playFrames: false,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.05, -0.5],
        offsetXrange: [-8, 8],
        offsetYrange: [-0, 24],
        sineX: 4,
        sineXperiod: 5,
        shrink: true,
    });
    exports.register({
        type: 'stars',
        frames: __spreadArray([], __read(sprites_sidecar_1.sprites.diveEffectsStar)),
        // accelY: 0.5,
        accelY: 0,
        minTimeSeconds: 0.5,
        maxTimeSeconds: 1.55,
        playFrames: false,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.05, -0.5],
        offsetXrange: [-8, 8],
        offsetYrange: [-0, 24],
        sineX: 4,
        sineXperiod: 5,
        shrink: true,
    });
};
exports.registerAll = registerAll;
var register = function (data) {
    entitiesUtils_sidecar_1.entitiesUtils.genericRegisterData(dataType, data, _default, dataList, dataMapType);
};
exports.register = register;
